





































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Danxuan from "./danxuan.vue";
import Xialadanxuan from "./xialadanxuan.vue";
import Duoxuan from "./duoxuan.vue";
import Wenjian from "./wenjian.vue";
import Biaoti from "./biaoti.vue";
import Shuzhiti from "./shuzhiti.vue";
import Wentizu from "./wentizu.vue";
import Biaochi from "./biaochi.vue";
import Wenbenti from "./wenbenti.vue";
import Shijian from "./shijian.vue";
import Zhuzhi from "./zhuzhi.vue";
import Sousuodanxuan from "./sousuodanxuan.vue";
import Sousuoduoxuan from "./sousuoduoxuan.vue";
@Component({
  components: {
    Danxuan,
    Xialadanxuan,
    Duoxuan,
    Wenjian,
    Biaoti,
    Shuzhiti,
    Wentizu,
    Biaochi,
    Wenbenti,
    Shijian,
    Zhuzhi,
    Sousuodanxuan,
    Sousuoduoxuan,
  },
})
export default class TransferCmp extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
  @Prop()
  private noDelete: any;
  private cZiduan: any = {};
  private ziduanChange(val) {
    console.log("改变");
    console.log(val);
    this.$emit("change", val);
  }
}
